import { FormikNumber } from "../../../../../components/FormikFields/FormikNumber.js";
import "react";
import { jsx } from "react/jsx-runtime";
//#region src/modules/ServicePeriods/activity-evals/occurrence/continuous/ContinuousOccurrenceForm.tsx
function ContinuousOccurrenceForm({ name }) {
	return /* @__PURE__ */ jsx("div", {
		className: "min-w-0 flex-1",
		children: /* @__PURE__ */ jsx(FormikNumber, {
			hint: "required",
			label: "Maximum gap",
			min: 1,
			name: `${name}.maxGapMinutes`,
			step: 1,
			subText: "Longest allowed quiet period, in minutes. Must be at least 1."
		})
	});
}
//#endregion
export { ContinuousOccurrenceForm };

//# sourceMappingURL=ContinuousOccurrenceForm.js.map